var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "header" }, [
    _c("div", { staticClass: "headerTitle" }, [
      _c("img", {
        staticClass: "logo hidden-xs-only",
        attrs: { src: require("../assets/img/smlogo.png"), alt: "" }
      }),
      _vm._v(" "),
      _c("span", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("m.guild_system_title")))
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "title hidden-sm-and-down" }, [
        _vm._v(
          _vm._s(
            _vm.$store.state.userInfo.guildName
              ? " - " + _vm.$store.state.userInfo.guildName
              : ""
          )
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "userInfo" },
      [
        _c("img", {
          staticClass: "photo hidden-xs-only",
          attrs: {
            src: _vm.$store.state.userInfo.guildLogo
              ? _vm.$store.state.userInfo.guildLogo
              : require("../assets/img/avatar.png"),
            alt: ""
          }
        }),
        _vm._v(" "),
        _c(
          "el-dropdown",
          [
            _c("span", { staticClass: "el-dropdown-link" }, [
              _c("span", [_vm._v(_vm._s(_vm.$store.state.userInfo.userName))]),
              _c("i", { staticClass: "el-icon-arrow-down el-icon--right" })
            ]),
            _vm._v(" "),
            _c(
              "el-dropdown-menu",
              { attrs: { slot: "dropdown" }, slot: "dropdown" },
              [
                !_vm.isApplyPage
                  ? _c(
                      "router-link",
                      { attrs: { to: "/guild/personal-center-page" } },
                      [
                        _c("el-dropdown-item", [
                          _vm._v(_vm._s(_vm.$t("m.account")))
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isApplyPage
                  ? _c(
                      "router-link",
                      { attrs: { to: "/guild/my-guild-detail" } },
                      [
                        _c("el-dropdown-item", [
                          _vm._v(_vm._s(_vm.$t("m.my_agency")))
                        ])
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-dropdown-item",
                  {
                    attrs: { divided: !_vm.isApplyPage },
                    nativeOn: {
                      click: function($event) {
                        return _vm.$store.commit("loginOut")
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("m.logout")))]
                )
              ],
              1
            )
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-704a719f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-704a719f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pageHead.vue
// module id = null
// module chunks = 